import React from 'react';
// scss
import 'components/Form/Input.scss';

const Textarea = ({
  className = '',
  name = '',
  placeholder,
  value = '',
  onChange,
  onKeyPress,
  onBlur,
  required,
  disabled,
  minLength,
  maxLength,
}) => {
  const inputProps = {
    // className: `textarea ${className}`,
    name,
    value,
  };

  // Додаємо min та max лише якщо вони задані
  if (placeholder !== undefined) inputProps.placeholder = placeholder;
  if (required !== undefined) inputProps.required = required;
  if (disabled !== undefined) inputProps.disabled = disabled;
  if (minLength !== undefined) inputProps.minLength = minLength;
  if (maxLength !== undefined) inputProps.maxLength = maxLength;

  if (onChange !== undefined) inputProps.onChange = e => onChange(e);
  if (onKeyPress !== undefined) inputProps.onKeyPress = e => onKeyPress(e);
  if (onBlur !== undefined) inputProps.onBlur = e => onBlur(e);

  return <textarea className={`textarea ${className}`} {...inputProps} />;
};

export default Textarea;
